<template>
  <div>
    <Breadcrumbs main="Пользователь" :title='userShow.username' />
    <Modal name="UserDocuments"
           title="Верификация документов"
           v-model="isShowDocsModal"
           :size="'lg'"
           :params="{ userDocuments: userDocumentList,
                      isLoadingDocs: isLoadedUserDocs,
                      error: errorText}"/>
    <b-modal centered id="modal-edit-username" title="Изменить username"
             v-model="isShowEditUsernameModal" hide-footer>
      <div>
        <label for="edit-username-input">Новый username</label>
        <b-form-input id="edit-username-input" v-model="newUsername" :state="usernameInputState"
                      maxlength="20" @keyup.enter="confirmEditUsername"/>
        <small class="text-muted">До 20 символов: латиница, цифры, "_" или "-".</small>
        <b-alert v-if="editUsernameError" show variant="danger" class="mt-2">{{ editUsernameError }}</b-alert>
        <div class="d-flex justify-content-end mt-3">
          <b-btn variant="secondary" class="mr-2" @click="isShowEditUsernameModal = false"
                 :disabled="isUpdatingUsername">
            Отмена
          </b-btn>
          <b-btn variant="primary" @click="confirmEditUsername"
                 :disabled="isUpdatingUsername || !isUsernameValid">
            {{ isUpdatingUsername ? 'Сохраняем...' : 'Сохранить' }}
          </b-btn>
        </div>
      </div>
    </b-modal>
    <div class="container-fluid px-0">
      <b-card class="mb-0">
        <form>
          <div class="d-flex align-items-center mb-3">
            <img :src="userShow?.avatar?.original_url || UserImagePug"
                 class="userLogo mr-3"
                 @error="event => event.target.src = UserImagePug"
            />
            <div class="d-flex flex-column align-items-start user-info-block">
              <div class="d-flex align-items-center flex-wrap">
                <h1 class="user-info-title mb-0 mr-2">{{ userShow.id }}. {{ userShow.username }}</h1>
                <b-btn variant="outline-secondary" size="sm" @click="openEditUsernameModal"
                       :title="'Изменить username'">
                  <i class="fa fa-pencil"></i>
                </b-btn>
              </div>
              <a :href="publicPageUrl" target="_blank">
                <b-btn variant="outline-primary" class="mt-2">
                  Перейти на публичную страницу
                </b-btn>
              </a>
            </div>
          </div>
        </form>
        <b-tabs>
          <b-tab title="Общее" active>
            <table class="table mt-5 user-table">
              <tr v-if="userShow?.currentBans.length">
                <th class="text-danger">Бан</th>
                <td>
                   <span v-for="(bans, idx) in userShow.currentBans" :key="bans.id">
                     Профиль {{bans?.game_name}} находится в бане от {{bans?.from}} до {{bans?.to}}
                     Причина: {{bans?.description}}
                  </span>
                </td>
              </tr>
              <tr>
                <th>Почта пользователя</th>
                <td>{{ userShow.email }}</td>
              </tr>
              <tr>
                <th>ФИО</th>
                <td>{{ userShow.full_name == null ? 'не указано' : userShow.full_name }}</td>
              </tr>
              <tr>
                <th>Дата рождения</th>
                <td>{{ userShow.birthday == null ? 'не указано' : userShow.birthday }}</td>
              </tr>
              <tr>
                <th>Страна</th>
                <td>{{ userShow.country == null ? 'не указано' : userShow.country.name }}</td>
              </tr>
              <tr>
                <th>Документы</th>
                <td>
                  <div v-if="userDocumentList?.length" class="">
                    <div v-for="file in userDocumentList" :key="'fileId' + file.id" class="mb-2 d-flex flex-wrap">
                      <b-btn variant="light" @click="isShowDocsModal = true">{{file.name}}</b-btn>
                      <b-btn variant="danger" class="ml-2" @click="deleteDocument({docId: file.id, userId: userShow.id})">Удалить</b-btn>
                    </div>
                  </div>
                  <div v-else>Нет загруженных документов</div>
                </td>
              </tr>
              <tr>
                <th>Язык пользователя</th>
                <td>{{ userShow?.lang?.code || 'не указано' }}</td>
              </tr>
              <tr>
                <th>Статус</th>
                <td class="d-md-flex">
                  <div>{{userShow.gameProfiles?.length <= 0 ? 'Не игровой/' : 'Игровой/'}}</div>
                  <div>{{userSocialAccountsShow <= 0 ? 'Не активирован' : 'Активирован'}}</div>
                  <b-btn
                      v-if="userSocialAccountsShow <= 0"
                      @click.prevent="changeStatus({userId: userShow.id})"
                      class="mb-2 ml-4"
                      v-model="userSocialAccountsShow"
                      :id="'makeActive' + userShow.id"
                  >
                    Активировать
                  </b-btn>
                </td>
              </tr>
              <tr>
                <th>Команды Pubg mobile</th>
                <td>
                   <span v-for="team in pubgTeams" :key="'teamPubgId-' + team.id">
                       <b-btn variant="link" @click="showTeamInfo(team.id)" style="color: black">
                               {{ team.name }}
                       </b-btn>
                  </span>
                </td>
              </tr>
              <tr>
                <th>Команды MLBB</th>
                <td>
                   <span v-for="team in mlbbTeams" :key="'teamMLBBId-' + team.id">
                       <b-btn variant="link" @click="showTeamInfo(team.id)" style="color: black">
                               {{ team.name }}
                       </b-btn>
                  </span>
                </td>
              </tr>
              <tr>
                <th>Рейтинг Pubg mobile</th>
                <td>{{userShow?.ratingPubgMobile?.rating}}</td>
              </tr>
              <tr>
                <th>Уровень</th>
                <td>
                  <div></div>
                </td>
              </tr>
            </table>
          </b-tab>
          <b-tab title="Игровые профиля">
            <game_profiles
                v-for="gameProfile in userProfilesForWork"
                :key="'gameProfile-' + gameProfile.id"
                @submit="getAllData"
                :game="gameProfile"
            />
            <div class="mt-3">
              <b-btn v-if="isShowAddGameProfileMLBB" @click="addMlbbGameProfile">Добавить игровой профиль по MLBB</b-btn>
              <b-btn v-if="isShowAddGameProfilePubgMobile" @click="addPubgMobileGameProfile">Добавить игровой профиль по PUBG MOBILE</b-btn>
            </div>
          </b-tab>
          <b-tab title="Верификация, Аккаунты">
            <table class="table mt-5">
              <tr>
                <th>Соцсеть</th>
                <th>Никнейм</th>
                <th>Данные (почта/номер)</th>
                <th>Страна</th>
                <th>Дата верификации</th>
                <th>Инструменты</th>
              </tr>
              <tr v-for="account in socialAccounts" :key="account.name">
                <td class="text-capitalize">{{ account.name }}</td>
                <td>
                  <template v-if="account.name === 'telegram' && account.link">
                    <a :href="account.link">@{{ account.link?.split('/').at(-1) }}</a>
                  </template>
                  <a v-else-if="account.nickname" :href="account.link">
                    {{ account.nickname }}
                  </a>
                  <template v-else>
                    -
                  </template>
                </td>
                <td>{{ account.email || account.phone || '-' }}</td>
                <td>{{ account.country || '-' }}</td>
                <td>{{ account.verifiedDate || '-' }}</td>
                <td>
                  <b-btn variant="primary"
                         v-if="!account.isPrimary"
                         @click="unlinkSocialAccount(account.id, $route.params.id)">
                    Отвязать
                  </b-btn>
                </td>
              </tr>
            </table>
          </b-tab>
          <b-tab title="Логи">
            <UserLogs/>
          </b-tab>
          <b-tab title="IP">
            <b-table
                responsive
                show-empty
                stacked="md"
                :striped="striped"
                :bordered="bordered"
                :fields="fieldsIp"
                :items="userLoginLogs"
                :current-page=0
                :per-page=10
                class="mt-5">
              <template #cell(country)="data">
                {{data.item?.country.name}}
              </template>
              <template #cell(ip)="data">
                {{data.item?.ip}}
              </template>
              <template #cell(device)="data">
                {{data.item?.data?.device}}
              </template>
              <template #cell(browser)="data">
                {{data.item?.data?.browser}}
              </template>
              <template #cell(platform)="data">
                {{data.item?.data?.platform}}
              </template>
              <template #cell(created_at)="data">
                {{data.item.created_at ? moment(data.item.created_at, 'YYYY-MM-DDTHH:mm:ss').format('DD.MM.YYYY HH:mm') : ''}}
              </template>
            </b-table>
            <b-col md="6" class="p-0">
              <b-pagination
                  @change="handlePageChange"
                  v-model="userLoginLogsCurrentPage"
                  :total-rows="userLoginLogsTotalPagination"
                  :per-page="10"
                  class="my-0 mt-5"
              ></b-pagination>
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import {UsersAdapterMixin} from "@/mixins/Users/UsersAdapterMixin";
import {ModalAdapterMixin} from "@/mixins/modal/ModalAdapterMixin";
import {TeamsAdapterMixin} from "@/mixins/Teams/TeamsAdapterMixin";
import game_profiles from "@/components/game_profiles";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import moment from 'moment'
import Modal from '@/components/modals/index.vue'
import api from "@/api/api";
import Vue from "vue";
import UserImagePug from '@/assets/images/pugs/team.png'
import UserLogs from "@/components/User/UserLogs";
import Env from '../../../env'

export default {
  name: 'UserInfo',
  mixins: [UsersAdapterMixin, ModalAdapterMixin, TeamsAdapterMixin, PaginationHelperMixin],
  components: {
    game_profiles,
    Modal,
    UserLogs
  },
  computed: {
    publicPageUrl() {
      const isTest = Env.API_URL.includes('backendtest')
      const baseUrl = isTest ? 'https://front.bigplay.gg' : 'https://bigplay.gg'
      return `${baseUrl}/user/${this.userShow.slug}`
    },
    userProfilesForWork() {
      return [...this.userShow?.gameProfiles, ...this.newGameProfiles]
    },
    isShowAddGameProfilePubgMobile() {
      return !this.userProfilesForWork.find(({ game }) => game.slug === 'pubg-mobile')
    },
    isShowAddGameProfileMLBB() {
      return !this.userProfilesForWork.find(({ game }) => game.slug === 'mlbb')
    },
    isUsernameValid() {
      const value = this.newUsername;
      return typeof value === 'string'
          && value.length > 0
          && value.length <= 20
          && this.usernameRegex.test(value);
    },
    usernameInputState() {
      if (!this.newUsername) return null;
      return this.isUsernameValid ? true : false;
    },
  },
  created() {
    this.getAllData();
    (async () => {
      this.isLoadedUserDocs = true
      const response = await api.docs.showUserDocs(this.$route.params.id)
          .catch((error) => {
            this.errorText = 'For view documents ' + error.response.data.message
          })
      this.userDocumentList = response.data.user_documents
      this.isLoadedUserDocs = false
    })()
    if(!this.isShowDocsModal) this.userDocumentList = []
  },
  data() {
    return {
      UserImagePug,
      moment,
      pageKey: 'pageNumberUserLoginLogs',
      isShowDocsModal: false,
      nick: '',
      pubg_id: '',
      fieldsIp: [
        {key: 'id', label: '№',},
        {key: 'country', label: 'Страна',},
        {key: 'ip', label: 'Ip'},
        {key: 'device', label: 'Устройство'},
        {key: 'browser', label: 'Браузер'},
        {key: 'platform', label: 'Платформа'},
        {key: 'created_at', label: 'Дата авторизации'},
      ],
      striped: true,
      bordered: true,
      newGameProfiles: [],
      mlbbTeams: [],
      pubgTeams: [],
      isLoadingDelete: false,
      userDocumentList: [],
      isLoadedUserDocs: false,
      errorText: null,
      isShowEditUsernameModal: false,
      isUpdatingUsername: false,
      newUsername: '',
      editUsernameError: null,
      usernameRegex: /^[a-zA-Z0-9_-]+$/,
    }
  },
  methods: {
    addPubgMobileGameProfile() {
      this.newGameProfiles.push({
        user_id: this.userShow.id,
        game_id: 1,
        game: {
          slug: 'pubg-mobile',
          name: 'PUBG MOBILE'
        },
        fields: {
          pubg_id: '',
          nick: ''
        }
      })
    },
    addMlbbGameProfile() {
      this.newGameProfiles.push({
        user_id: this.userShow.id,
        game_id: 3,
        game: {
          slug: 'mlbb',
          name: 'MLBB'
        },
        fields: {
          mlbb_id: '',
          nick: ''
        }
      })
    },
    async getAllData() {
      Promise.all([
        await this.showUser(this.$route.params.id),
        this.recordPageToStorage(this.userLoginLogsCurrentPage, this.pageKey),
        this.grabUserLoginLogs({
          pageNumber: this.getCurrentPageNumber(this.pageKey),
          userId: this.$route.params.id,
        })
      ])
      this.newGameProfiles = []
      this.mlbbTeams = this.userShow.teams.filter((team) => team.game_id === 3)
      this.pubgTeams = this.userShow.teams.filter((team) => team.game_id === 1)
    },
    handlePageChange(pageNumber) {
      this.recordPageToStorage(pageNumber, this.pageKey)
      this.grabUserLoginLogs({
        pageNumber: pageNumber,
        userId: this.$route.params.id,
      })
    },
    async deleteDocument(params) {
      await api.docs.delete(params.docId)
          .then(() => {
            Vue.toasted.success('Документ успешно удален', {duration: 3000})
            this.userDocumentList = this.userDocumentList.filter((doc) => doc.id !== params.docId)
          })
          .catch((error) => {
            Vue.toasted.error(error.response.data.message, {duration: 3000})
          })
    },
    openEditUsernameModal() {
      this.newUsername = this.userShow.username || '';
      this.editUsernameError = null;
      this.isShowEditUsernameModal = true;
    },
    async confirmEditUsername() {
      if (!this.isUsernameValid || this.isUpdatingUsername) return;
      this.isUpdatingUsername = true;
      this.editUsernameError = null;
      try {
        await api.users.updateUsername(this.$route.params.id, this.newUsername);
        this.isShowEditUsernameModal = false;
        Vue.toasted.success('Username успешно обновлён', {duration: 3000});
        await this.showUser(this.$route.params.id);
      } catch (error) {
        const data = error?.response?.data;
        const errors = data?.errors;
        if (errors && typeof errors === 'object') {
          const first = Object.values(errors).find(v => Array.isArray(v) && v.length);
          this.editUsernameError = first ? first[0] : (data.message || 'Не удалось обновить username');
        } else {
          this.editUsernameError = data?.message || 'Не удалось обновить username';
        }
      } finally {
        this.isUpdatingUsername = false;
      }
    },
  }
}
</script>

<style scoped>
.userLogo {
  width: 80px;
  height: 80px;
  min-width: 80px;
  object-fit: cover;
  border-radius: 50%;
}
.user-info-block {
  flex: 1 1 0;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.user-info-title {
  word-break: break-word;
  overflow-wrap: break-word;
}
.user-info-block a {
  max-width: 100%;
}
.user-info-block .btn {
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.user-table {
  table-layout: fixed;
  width: 100%;
}
.user-table td {
  word-break: break-word;
  overflow-wrap: break-word;
}
@media (max-width: 575.98px) {
  .userLogo {
    width: 48px;
    height: 48px;
    min-width: 48px;
  }
  .user-info-block > a {
    width: calc(100% + 48px + 1rem);
    max-width: none;
    margin-left: calc(-48px - 1rem);
    text-align: center;
  }
}
</style>